import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    name: 'María Fernández',
    location: 'Quito, Ecuador',
    text: '"¡Qué manera tan especial de conocer Guayaquil! Ver el Malecón desde el río fue mágico. Mi hija de 8 años no dejaba de tomar fotos y mi esposo quedó fascinado con las explicaciones históricas del guía. Definitivamente volveremos en nuestro próximo viaje."',
    rating: 5,
    date: 'Marzo 2023',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80'
  }, {
    name: 'John Smith',
    location: 'Estados Unidos',
    text: '"Como turista extranjero, esta fue la mejor manera de apreciar Guayaquil. El capitán Carlos fue extraordinario explicando cada detalle. El momento del atardecer con esa luz dorada sobre el río... simplemente inolvidable. Lo recomendaré a todos mis amigos que visiten Ecuador."',
    rating: 5,
    date: 'Enero 2023',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80'
  }, {
    name: 'Carlos Mendoza',
    location: 'Guayaquil, Ecuador',
    text: '"Nací y crecí en Guayaquil, pero nunca había visto mi ciudad así. Celebramos el cumpleaños de mi esposa a bordo y fue perfecto. La brisa del río, las luces de la ciudad al anochecer... hasta vi partes de la ciudad que no conocía desde este ángulo. Una experiencia que todo guayaquileño debería vivir."',
    rating: 5,
    date: 'Mayo 2023',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80'
  }];
  return <section id="testimonios" className="section bg-navy/5 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-gold/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-40 left-10 w-80 h-80 bg-turquoise/5 rounded-full blur-3xl"></div>
      <div className="container relative z-10">
        <div className="text-center mb-16 reveal-up">
          <span className="inline-block text-turquoise font-medium mb-3 transform transition-all duration-700 translate-y-10 opacity-0 animate-title-appear">
            TESTIMONIOS
          </span>
          <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-6 transform transition-all duration-700 translate-y-10 opacity-0 animate-title-appear" style={{
          animationDelay: '200ms'
        }}>
            Voces de Navegantes{' '}
            <span className="text-turquoise relative">
              Satisfechos
            </span>
          </h2>
          <div className="w-24 h-1 bg-turquoise mx-auto mb-8 transform transition-all duration-700 scale-x-0 animate-line-expand" style={{
          animationDelay: '400ms'
        }}></div>
          <p className="max-w-2xl mx-auto text-lg">
            Estas son algunas de las experiencias compartidas por quienes ya han
            vivido la magia de recorrer el río Guayas con nosotros
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-lg flex flex-col h-full relative reveal-up" style={{
          animationDelay: `${index * 200}ms`
        }}>
              <div className="absolute -top-5 -left-5 text-turquoise opacity-20">
                <QuoteIcon className="h-16 w-16" />
              </div>
              <div className="flex mb-6 z-10">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-gold fill-current" />)}
              </div>
              <p className="italic mb-8 flex-grow text-navy/80 z-10">
                {testimonial.text}
              </p>
              <div className="flex items-center">
                <div className="h-14 w-14 rounded-full overflow-hidden mr-4">
                  <img src={testimonial.image} alt={testimonial.name} className="h-full w-full object-cover" />
                </div>
                <div>
                  <p className="font-semibold text-navy">{testimonial.name}</p>
                  <p className="text-sm text-navy/60">{testimonial.location}</p>
                </div>
                <div className="ml-auto text-xs bg-navy/5 text-navy/60 py-1 px-2 rounded">
                  {testimonial.date}
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-16 text-center reveal-up">
          <div className="bg-white p-8 rounded-lg shadow-lg inline-block max-w-2xl mx-auto">
            <p className="text-xl font-playfair italic text-navy">
              "Más de 2,000 visitantes han disfrutado de nuestros paseos desde
              2021, con una calificación promedio de{' '}
              <span className="text-turquoise font-semibold">
                4.9/5 estrellas
              </span>
              "
            </p>
            <div className="mt-6 flex justify-center">
              <button className="btn bg-navy hover:bg-turquoise text-white px-8 py-3 rounded-md transition-colors">
                Reserva tu experiencia
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};